import { replaceSpecialChars } from 'cpool-utils';
import { z } from 'zod';

export const schemaConsorsStreet = z
    .string()
    .min(2)
    .max(32)
    .transform(replaceSpecialChars)
    .refine(
        (val) => {
            return /^[0-9a-zA-ZßäöüÖÄÜ.,/ -]+$/u.test(val);
        },
        { message: 'Invalid characters' },
    );
export type SchemaConsorsStreet = z.infer<typeof schemaConsorsStreet>;
